var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login_container",staticStyle:{"margin-top":"30vh"}},[_c('b-row',{staticClass:"login-row"},[_c('b-col',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"width":"100","height":"100"}}),_c('h3',{staticClass:"text-white mt-4"},[_vm._v("J.L. AI® est en cours de mise à jour.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }